<template>
  <div>
    <div style="display: flex; align-items: center">
      <label style="white-space: nowrap">审核项：</label>
      <el-select v-model="type" placeholder="Select" style="width: 100%">
        <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div class="dialog-footer" style="text-align: center; margin-top: 16px">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import { updatePerfectState } from '@/api/url'
import { postFormData } from "@/api/api";

export default {
  name: "PairDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArr: this.value.idArr,
      state: this.value.state,
      loading: false,

      typeArray: [
        {label: '全部', value: 0},
        {label: '理想的另一半', value: 1},
        {label: '闲暇喜好', value: 2},
      ],
      type: 0,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    submit() {
      this.loading = true
      let param = {}
      param['idArr'] = this.idArr;
      if(this.type == 0) {
        param['idealHimState'] = this.state
        param['hobbyState'] = this.state
      }else if(this.type == 1){
        param['idealHimState'] = this.state
      }else {
        param['hobbyState'] = this.state
      }
      postFormData(updatePerfectState, param).then((data)=>{
        let {code, msg} = data
        if(code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
